/* error-handling.ts */

/* Helper */
import { hasKeys } from "src/utils/guards/key-validator";

/* Interfaces */
import { TwoFaProps } from "src/shared/interfaces/common/Auth";

export const isTwoFaErrorProps = (
  obj: unknown
): obj is TwoFaProps => {
  return hasKeys<TwoFaProps>(obj, [
    "credentials",
    "qrCodeRequired",
    "twoFaRequired",
  ]);
};
